// extracted by mini-css-extract-plugin
export default {"wrapper":"ReactionVolumeInputs_wrapper__L-org","value":"ReactionVolumeInputs_value__9rkH1"};